import React, { useState, useEffect } from "react";
import "./Testimonials.css";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Lebogang Ratlhallane",
      text: "Still crushing on this day, thank you for capturing all the moments for us",
      role: "Client",
    },
    {
      name: "Nwabisa Gobile",
      text: "Oh, thank you FleurDesignsPhotography for capturing these beautiful memories.",
      role: "Customer",
    },
    {
      name: "Rachel Efraaim",
      text: "Mbali, your work is beautiful.",
      role: "Happy Client",
    },
  ];

  const [current, setCurrent] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      // Start fade-out animation
      setFade(false);

      // Wait for fade-out to finish before changing slide
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % testimonials.length);
        setFade(true); // fade back in
      }, 400);
    }, 5000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <div id="testimonials" className="testimonials">
      <h2 className="testimonials-title">What Clients Say</h2>

      <div className={`testimonial-card ${fade ? "fade-in" : "fade-out"}`}>
        <p className="testimonial-text">“{testimonials[current].text}”</p>
        <h3 className="testimonial-name">— {testimonials[current].name}</h3>
        <p className="testimonial-role">{testimonials[current].role}</p>
      </div>

      <div className="indicator-row">
        {testimonials.map((_, index) => (
          <div
            key={index}
            className={`indicator-dot ${
              current === index ? "active-dot" : ""
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
